import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API,  API_EndPointActivityData,  getApiUrl } from '../../config';
import { ModuleData } from '../../crm/types';


interface FetchActivityDataParams {
  learningJourneyId: string;
  moduleId: string;
}
// Define the initial state
const initialState: any = [];

export const fetchActivityData = createAsyncThunk(
  'modules/fetchData',
  async (params: FetchActivityDataParams) => {
    const { learningJourneyId, moduleId } = params;
    if (!learningJourneyId || !moduleId) {
      throw new Error('Missing required parameters: learningJourneyId or moduleId');
    }

    try {
      const apiUrl: string = getApiUrl(`${API_EndPointActivityData}`);
      const response = await API.get(`${apiUrl}/${learningJourneyId}/${moduleId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }
);


// Create the slice
const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchActivityData.fulfilled, (state, action) => {
      return action.payload;
    });
  },
});

// Export the async thunk and reducer
export const { reducer: activityReducer } = activitySlice;
// export { fetchActivityData };
